import { render } from "./AppDashboard.vue?vue&type=template&id=26b45efe"
import script from "./AppDashboard.vue?vue&type=script&lang=js"
export * from "./AppDashboard.vue?vue&type=script&lang=js"

import "./AppDashboard.vue?vue&type=style&index=0&id=26b45efe&lang=css"

import exportComponent from "/home/dqlm/crypt/proj/eaxlabs_svn/fvemon/trunk/src/uiwww/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__